<template>
  <div>
    <div class="applyment">
      <el-button type="primary" @click="apply">申请结算</el-button>
    </div>
    <!-- 搜索 -->
    <el-form :inline="true" :model="search" class="demo-form-inline">
      <div class="search">
        <el-form-item label="产品名称">
          <el-select v-model="search.productId" placeholder="请选择" filterable>
            <el-option v-for="item in productList" :key="item.id" :label="item.NAME" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""></el-form-item>
        <el-form-item label=""></el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="queryData" style="margin-right: 8px">搜索
          </el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </div>
    </el-form>
    <table-total ref="total" :type="2" />
    <!-- 投放数据 -->
    <!-- 数据列表 -->
    <el-table :key="tableKey" ref="multipleTable" v-loading="listLoading" stripe :data="list" tooltip-effect="dark"
      style="width: 100%" :height="tableHeight" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="55">
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="产品名称" min-width="100px">
        <template slot-scope="scope">{{
            emptyDeal(scope.row.productName)
        }}
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="投放任务" min-width="100px">
        <template slot-scope="scope">{{
            emptyDeal(scope.row.packageName)
        }}
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="账单日期" min-width="100px">
        <template slot-scope="scope">{{
            scope.row.endTime
              ? date(scope.row.startTime) + "至" + date(scope.row.endTime)
              : date(scope.row.startTime) + "至今"
        }}
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="数据/订单额" min-width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.billingType == '263'">{{ moneyTrans(scope.row.trafficUserApprovalDataNums) }}</span>
          <span v-else>{{ emptyDeal(scope.row.trafficUserApprovalDataNums) }}</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="佣金（含税）" min-width="100px">
        <template slot-scope="scope">
          {{ moneyTrans(scope.row.trafficUserApprovalMoney) }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="mt10">
      <el-pagination :key="pageInfo.currentPage" :current-page="pageInfo.currentPage" :page-size="pageInfo.limit"
        layout="total,sizes, prev, pager, next" :total="pageInfo.allCount" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>
<script>
import { getUnApplyList } from "@/api/bill";
import { estimateDetail, getProduct } from "@/api/launch";
import {
  emptyTrans,
  formatMoney,
  formatDate,
  statusTrans,
  countCurrentPage,
} from "@/api/dataTrans.js";
import TableTotal from "@/components/TableTotal";
import Setting from "@/settings.js";

var { pageConfig } = Setting;
export default {
  components: {
    TableTotal,
  },
  data() {
    return {
      search: {
        productId: null,
      },
      dialogDetail: false,
      productList: [],
      statuList: [
        { name: "投放中", id: 223 },
        { name: "投放结束", id: 226 },
      ],
      list: [],
      tableKey: 0,
      pageInfo: {
        limit: pageConfig["limit"],
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false, // 是否显示快捷编辑代码框
      },
      tableHeight: document.body.clientHeight - 400,
      listLoading: false,
      detailData: {},
      searchData: {},
      total: {},
      intervalIds: null,
      trafficUserId: null,
    };
  },
  mounted() {
    this.getList();
    window.onresize = function () {
      this.tableHeight = document.body.clientHeight - 400;
    };
    // 获取所有产品列表
    getProduct().then((res) => {
      if (res && res.code == 0) {
        this.productList = res.data;
      }
    });
  },
  methods: {
    date(_val) {
      return formatDate(_val);
    },
    status(val) {
      return statusTrans(val, this.statuList);
    },
    getList() {
      const _this = this;
      var pramaList = {};
      pramaList = this.search;
      getUnApplyList({
        pageNo: this.pageInfo.currentPage,
        pageSize: this.pageInfo.limit,
        ...pramaList,
      }).then((res) => {
        if (res && res.code == 0) {
          _this.list = res.data.items;
          _this.pageInfo.allCount = res.data.total;
          _this.trafficUserId = res.data.additional.trafficUserId;
          var _totalData = [
            {
              title: "佣金(含税)",
              currentNum: countCurrentPage(
                "trafficUserApprovalMoney",
                res.data.items
              ),
              totalNum: res.data.additional.trafficUserApprovalMoneySum,
            },
          ];
          _this.$refs.total.initData(_totalData);
        }
      });
    },
    queryData() {
      this.pageInfo.currentPage = 1;
      this.getList();
    },
    resetSearch(formName) {
      this.search = this.$options.data().search;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getList();
    },
    // 空字符转换
    emptyDeal(_val) {
      return emptyTrans(_val);
    },
    // 货币格式转换
    moneyTrans(_val) {
      return formatMoney(_val);
    },
    handleSelectionChange(rows) {
      if (rows.length > 0) {
        var intervalIds = "";
        rows.forEach((item) => {
          intervalIds += item.intervalId + ",";
        });
        this.intervalIds = intervalIds.slice(0, intervalIds.length - 1);
      }
    },
    // 提交申请
    apply() {
      if (
        this.intervalIds == null ||
        this.intervalIds == "" ||
        this.intervalIds == undefined
      ) {
        this.$message.error("请至少选择一条数据");
      } else {
        this.$router.push({
          path: "/applysettlement",
          query: { intervalIds: this.intervalIds, userId: this.trafficUserId },
        });
      }
      // this.$router.push({
      //   path: "/applysettlement",
      //   query: { intervalIds: this.intervalIds, userId: this.trafficUserId },
      // });
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-form-item__label {
  text-align: left;
}

/deep/ .el-input {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-form-item {
  margin-bottom: 16px;
}

.icon {
  display: none;
  text-align: center;
}

/deep/ .el-form-item__label {
  text-align: right;
}

.iconfont {
  display: none;
}

/deep/ .el-form-item {
  width: 90%;
  margin-bottom: 22px;
}

.list-container {
  background-color: #fff;
  padding: 24px;
  margin-right: 24px;
}

.applyment {
  position: absolute;
  top: -55px;
  right: 10px;
}
</style>
